import React from 'react';
import { Route, Redirect } from 'react-router-dom';
import { UserRole, isAuthGuardActive, panelRoot } from 'constants/defaultValues';
import { getCurrentUser } from './Utils';

const checkRoles = (roles, userRoles) => {
  // eslint-disable-next-line no-restricted-syntax
  for (const role of roles) {
    if (userRoles.includes(role)) return true;
  }
  return false;
};

// eslint-disable-next-line import/prefer-default-export
export const ProtectedRoute = ({
  component: Component,
  roles = undefined,
  ...rest
}) => {
  const setComponent = (props) => {
    if (isAuthGuardActive) {
      const currentUser = getCurrentUser();
      if (currentUser) {
        if (roles) {
          if (checkRoles(roles, currentUser.roles)) {
            return <Component {...props} />;
          }
          return (
            <Redirect
              to={{
                pathname: '/unauthorized',
                state: { from: props.location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }
      return (
        <Redirect
          to={{
            pathname: '/user/login',
            state: { from: props.location },
          }}
        />
      );
    }
    return <Component {...props} />;
  };

  return <Route {...rest} render={setComponent} />;
};

// eslint-disable-next-line import/prefer-default-export
export const ProtectedRedirectWithRole = ({
  from = undefined,
  roles = [],
  history = undefined,
  match
}) => {
  // if (isAuthGuardActive) {
  //   const currentUser = getCurrentUser();
  //   if (currentUser) {
  //     if (roles.length > 0) {
  //       for (let i = 0; i < roles.length; i++) {
  //         if (checkRoles(roles[i]?.roles, currentUser.roles)) {
  //           console.log({ from, f: roles[i]?.path, history })
  //           // if (from == `${match.url}/`)
  //           // history?.push(roles[i]?.path)
  //           return (
  //             <Redirect
  //               exact
  //               from={from}
  //               to={roles[i]?.path}
  //             />
  //           )
  //         }
  //       }
  //     }
  //   }
  // }
  return null;
};


export const getHomePath = (user) => {
  let redirectTo = '';
  if (checkRoles([UserRole.Admin, UserRole.Manager], user.roles ?? [])) {
    redirectTo = `${panelRoot}/dashboards/default`;
  } else if (checkRoles([UserRole.Advisor], user.roles ?? [])) {
    redirectTo = `${panelRoot}/mukebs/admin`;
  } else if (checkRoles([UserRole.Storekeeper], user.roles ?? [])) {
    redirectTo = `${panelRoot}/store/storelist`;
  } else if (checkRoles([UserRole.ManagerReporter,UserRole.Reporter], user.roles ?? [])) {
    redirectTo = `${panelRoot}/reporter/plates`;
  } else if (checkRoles([UserRole.Callcenter], user.roles ?? [])) {
    redirectTo = `${panelRoot}/mukebs/admin`;
  } else {
    redirectTo = `${panelRoot}/mukebs/create`;
  }
  return redirectTo;
}


// eslint-disable-next-line import/prefer-default-export
export const PublicRoute = ({ component: Component, restricted, ...rest }) => {
  const setComponent = (props) => {
    if (isAuthGuardActive) {
      const currentUser = getCurrentUser();
      if (currentUser) {

        if (restricted) {

          const redirectTo = getHomePath(currentUser)

          console.log({ info: "login here", restricted, redirectTo })
          return (
            <Redirect
              to={{
                pathname: redirectTo,
                state: { from: props.location },
              }}
            />
          );
        }
        return <Component {...props} />;
      }
      return <Component {...props} />;
    }
    return <Component {...props} />;
  };
  return <Route {...rest} render={setComponent} />;
};
